import { render, staticRenderFns } from "./Dwdcqkdj.vue?vue&type=template&id=64002e06"
import script from "./Dwdcqkdj.vue?vue&type=script&lang=js"
export * from "./Dwdcqkdj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports